import { Logo } from './Logo';
import styles from './FullPageLoader.module.css';

/**
 * Shown while the app works out who the visitor is, or while a lazy route
 * chunk downloads.
 */
export function FullPageLoader({ label = 'Laden…' }: { label?: string }) {
    return (
        <div className={styles.screen} role="status" aria-live="polite">
            <Logo size="lg" />
            <div className={styles.track} aria-hidden="true">
                <span className={styles.bar} />
            </div>
            <p className={styles.label}>{label}</p>
        </div>
    );
}
